import { AppFeatures } from '@ddt-web/domain';

export class AppFeaturesConfig {
	public static readonly APP_FEATURES: Map<string, AppFeatures> = new Map([
		[
			'portfolio-centre-360', {
				riskProxy: false,
				correlationMatrix: true
			}
		],
		[
			'portfolio-analysis-construction', {
				riskProxy: true,
				correlationMatrix: true
			}
		]
	]);
}
